<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Diretórios e Arquivos do Esccritório / {{
                    client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <tabMenuClient :id="client.id" :type="client.type"></tabMenuClient>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow">

                            <div class="card-header mt-3">
                                <span v-for="(hierarchy, index) in hierarchy_directories" :key="index"><button
                                        class="btn btn-link"
                                        @click="beforeDirectory(hierarchy.from != null ? hierarchy.from.id : null)"><i
                                            class="fa fa-arrow-left"></i> Voltar</button> | <strong>Diretório
                                        atual:</strong> <span v-for="(item, index) in sequence_directories"
                                        :key="index">
                                        {{ item }} </span></span>

                                <div class="dropdown float-right mb-4">
                                    <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-plus"> </i> Novo
                                    </button>
                                    <div class="dropdown-menu animated--fade-in" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item" @click="showModalNewDirectory()"><i
                                                class="fa fa-folder"></i> Diretório</button>
                                        <button class="dropdown-item" @click="showModalNewFile()"><i
                                                class="fa fa-file"></i> Arquivo</button>
                                    </div>
                                </div>
                                <div class="dropdown float-right mb-4 mr-4">
                                    <button class="btn btn-secondary" type="button" @click="changeViewingMode()">
                                        <i class="fa fa-eye"> </i> Modo {{ viewing_mode == 'list' ? 'grade' : 'lista' }}
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <div v-if="viewing_mode == 'card'">
                                    <div class="row" v-if="directories.length <= 0 && files.length <= 0">
                                        <div class="col-sm-12 col-xs-12 col-lg-12">
                                            <div class="alert alert-danger">
                                                Ops...Diretório vazio =/
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3 col-lg-3 col-sm-12 mb-3" v-for="(directory) in directories"
                                            :key="directory.id">
                                            <div class="card shadow border-left-danger">
                                                <!-- Card Header - Dropdown -->
                                                <div
                                                    class="card-header d-flex flex-row align-items-center justify-content-between">
                                                    <h6 class="m-0 font-weight-bold text-primary">Diretório <span
                                                            v-if="directory.to.roles.length > 0"><i
                                                                class="fa fa-lock"></i></span>
                                                        <span v-else><i class="fa fa-unlock"></i></span>
                                                    </h6>
                                                    <div class="dropdown no-arrow">
                                                        <a class="dropdown-toggle" href="#" role="button"
                                                            id="dropdownMenuLink" data-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                                        </a>
                                                        <div class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                                                            aria-labelledby="dropdownMenuLink">
                                                            <div class="dropdown-header">Ações:</div>
                                                            <a class="dropdown-item" href="#"
                                                                @click="mirrorAreaClient(directory.to.name, directory.uuid_to)">Espelhar
                                                                arquivos área cliente</a>
                                                            <div class="dropdown-divider"></div>
                                                            <a class="dropdown-item" href="#"
                                                                @click="editDirectory(directory.id)">Editar</a>
                                                            <div class="dropdown-divider"></div>
                                                            <a class="dropdown-item" href="#"
                                                                @click="removeDirectory(directory.id)">Remover</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Card Body -->
                                                <div class="card-body pointer m-0"
                                                    @click="enterDirectory(directory.uuid_to, directory.to.name)">
                                                    <p><i class="fa fa-folder fa-3x mr-3 m-0"></i> <button
                                                            class="btn btn-link">{{ directory.to.name }}</button></p>
                                                </div>
                                                <div class="card-footer m-0">
                                                    <p class="text-left"><small>Criado em: {{ directory.to.created_at
                                                            }}</small> <small
                                                            class="ml-5"><strong>Subdiretórios:</strong> {{
                                                                directory.to.totalSubdirectories }}</small> </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-lg-3 col-sm-12 mb-3" v-for="(file) in files"
                                            :key="file.id">
                                            <div class="card shadow border-left-success ">
                                                <!-- Card Header - Dropdown -->
                                                <div
                                                    class="card-header d-flex flex-row align-items-center justify-content-between">
                                                    <h6 class="m-0 font-weight-bold text-primary">Arquivo
                                                    </h6>
                                                    <div class="dropdown no-arrow">
                                                        <a class="dropdown-toggle" href="#" role="button"
                                                            id="dropdownMenuLink" data-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                                        </a>
                                                        <div class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                                                            aria-labelledby="dropdownMenuLink">
                                                            <div class="dropdown-header">Ações:</div>
                                                            <a class="dropdown-item" href="#"
                                                                @click="downloadFile(file.id)">Baixar arquivo</a>
                                                            <a class="dropdown-item" href="#"
                                                                @click="editFile(file.id)">Editar</a>
                                                            <div class="dropdown-divider"></div>
                                                            <a class="dropdown-item" href="#"
                                                                @click="removeFile(file.id)">Remover</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Card Body -->
                                                <div class="card-body pointer m-0" @click="downloadFile(file.id)">
                                                    <p><i class="fa fa-file fa-3x mr-3 m-0"></i> <button
                                                            class="btn btn-link">{{ file.description }}</button></p>
                                                </div>
                                                <div class="card-footer m-0">
                                                    <p class="text-left"><small>Criado em: {{
                                                        file.created_at }}</small> <small class="ml-5"></small> </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="viewing_mode == 'list'">
                                    <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Nome</th>
                                                    <th class="text-center">Vencimento</th>
                                                    <th class="text-center">Nº Download</th>
                                                    <th class="text-center">Criado em</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="pointer" v-for="(directory, index) in directories"
                                                    :key="index.id">
                                                    <td @click="enterDirectory(directory.uuid_to, directory.to.name)">{{
                                                        index + 1 }}</td>
                                                    <td @click="enterDirectory(directory.uuid_to, directory.to.name)"><i
                                                            class="fa fa-folder directory"></i> {{ directory.to.name }}
                                                    </td>
                                                    <td class="text-center">-</td>
                                                    <td class="text-center">-</td>
                                                    <td class="text-center"
                                                        @click="enterDirectory(directory.uuid_to, directory.to.name)">{{
                                                            directory.to.created_at }} </td>
                                                    <td>
                                                        <div class="dropdown">
                                                            <button class="btn btn-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                Ações
                                                            </button>
                                                            <div class="dropdown-menu animated--fade-in"
                                                                aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item" href="#"
                                                                    @click="mirrorAreaClient(directory.to.name, directory.uuid_to)">Espelhar
                                                                    arquivos área cliente</a>
                                                                <a class="dropdown-item" href="#"
                                                                    @click="editDirectory(directory.id)">Editar</a>
                                                                <a class="dropdown-item" href="#"
                                                                    @click="removeDirectory(directory.id)">Remover</a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-show="directories.length <= 0 && files.length <= 0">
                                                    <td colspan="7" class="text-center">Nenhum registro encontrado</td>
                                                </tr>
                                            </tbody>
                                            <tbody>
                                                <tr class="pointer" v-for="(file, index) in files" :key="index.id">
                                                    <td>{{ index + 1 }}</td>
                                                    <td @click="downloadFile(file.id)"><i class="fa fa-file file"></i>
                                                        {{ file.description }}
                                                        <div v-if="file.request_confirmation">
                                                            <span class="badge badge-success"
                                                                v-if="file.confirmation"><i class="fa fa-check"></i>
                                                                Confirmado</span>
                                                            <span class="badge badge-warning"
                                                                v-if="!file.confirmation"><i
                                                                    class="fa fa-hourglass"></i> Confirmação
                                                                Pendente</span>
                                                        </div>

                                                    </td>
                                                    <td class="text-center">{{ file.overdue ? file.overdue_formatted :
                                                        '-'
                                                        }}
                                                        <div v-if="file.request_confirmation && !file.confirmation">
                                                            <span class="badge badge-danger" v-if="file.is_expired"><i
                                                                    class="fa fa-exclamation"></i> Vencido</span>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">{{ file.number_download }} </td>
                                                    <td class="text-center">{{ file.created_at }} </td>
                                                    <td>
                                                        <div class="dropdown">
                                                            <button class="btn btn-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                Ações
                                                            </button>
                                                            <div class="dropdown-menu animated--fade-in"
                                                                aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item" href="#"
                                                                    @click="downloadFile(file.id)">Baixar arquivo</a>
                                                                <a class="dropdown-item" href="#"
                                                                    @click="editFile(file.id)">Editar</a>
                                                                <a class="dropdown-item" href="#"
                                                                    @click="removeFile(file.id)">Remover</a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->

    <div id="modalDisplayNewDirectory" class="modal" :style="{ display: modalDisplayNewDirectory }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewDirectory">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newDirectoryLabel">Novo diretório</h5>
                            <button type="button" class="close" @click="closeModalNewDirectory()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição</label>
                                    <input type="text" class="form-control" placeholder="Ex: Financeiro"
                                        v-model="directory.name">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Perfil para acesso</label>
                                    <multiselect v-model="role_multiselect" :options="roles_options"
                                        :custom-label="roleWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        track-by="key" :close-on-select="false" :clear-on-select="false"
                                        :multiple="true">

                                        <template #noResult>
                                            Nenhum perfil encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalNewDirectory()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory" :disabled='!isDisabledDirectory'><i
                                    class="fa fa-save"></i>
                                Cadastrar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayEditDirectory" class="modal" :style="{ display: modalDisplayEditDirectory }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateDirectory">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newDirectoryLabel">Atualizar diretório</h5>
                            <button type="button" class="close" @click="closeModalEditDirectory()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição</label>
                                    <input type="text" class="form-control" placeholder="Ex: Financeiro"
                                        v-model="directory.name">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Perfil para acesso</label>
                                    <multiselect v-model="role_multiselect" :options="roles_options"
                                        :custom-label="roleWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        track-by="key" :close-on-select="false" :clear-on-select="false"
                                        :multiple="true">

                                        <template #noResult>
                                            Nenhum perfil encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalEditDirectory()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory" :disabled='!isDisabledDirectory'><i
                                    class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayNewFile" class="modal" :style="{ display: modalDisplayNewFile }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewFile">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Enviar arquivo</h5>
                            <button type="button" class="close" @click="closeModalNewFile()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row mt-2">
                                <div class="col-sm-12 col-xs-6 col-lg-6 mt-2">
                                    <label for="">Vencimento</label>
                                    <input type="date" class="form-control" v-model="file.overdue">
                                </div>
                                <div class="col-sm-12 col-xs-6 col-lg-6 mt-2">
                                    <label for="">Solicitar confirmação liquidação</label>
                                    <multiselect v-model="request_confirmation_multiselect"
                                        :options="request_confirmation_options"
                                        :custom-label="requestConfirmationWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectRequestConfirmation">

                                        <template #noResult>
                                            Nenhuma opção encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small>Tamanho máximo: 10MB</small>
                                    <input type="file" multiple @change="handleFileChange" ref="fileInput">
                                </div>
                            </div>
                            <div class="row mt-3" v-if="file.size != ''">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small class="mt-5">Tamanho arquivo selecionado: {{ file.size }}</small>
                                </div>
                            </div>
                            <div class="row" v-if="files_upload.length > 0">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Descrição</th>
                                                    <th>Tamanho</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(file, index) in files_upload" :key="index">
                                                    <td>{{ file.name }} </td>
                                                    <td>{{ (file.size / (1024 * 1024)).toFixed(2) }} MB </td>
                                                    <td><i class="fa fa-times pointer"
                                                            @click="removeFileList(file)"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-5" v-if="progressBarFile > 0">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <div class="progress">
                                        <div class="progress-bar bg-success" role="progressbar"
                                            :style="'width:' + progressBarFile + '%'" aria-valuenow="25"
                                            aria-valuemin="0" aria-valuemax="100">Progresso</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalNewFile()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory" :disabled='!isDisabledFile'><i
                                    class="fa fa-save"></i>
                                Cadastrar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayEditFile" class="modal" :style="{ display: modalDisplayEditFile }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateFile">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Atualizar arquivo</h5>
                            <button type="button" class="close" @click="closeModalEditFile()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição*</label>
                                    <input type="text" class="form-control" placeholder="Ex: PDF Boleto ISS"
                                        v-model="file.description">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12 col-xs-6 col-lg-6 mt-2">
                                    <label for="">Vencimento</label>
                                    <input type="date" class="form-control" v-model="file.overdue">
                                </div>
                                <div class="col-sm-12 col-xs-6 col-lg-6 mt-2">
                                    <label for="">Solicitar confirmação liquidação</label>
                                    <multiselect v-model="request_confirmation_multiselect"
                                        :options="request_confirmation_options"
                                        :custom-label="requestConfirmationWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectRequestConfirmation">

                                        <template #noResult>
                                            Nenhuma opção encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalEditFile()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveFile" :disabled='!isDisabledFileUpdate'><i
                                    class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import tabMenuClient from './tab-menu-client.vue';
import Multiselect from 'vue-multiselect'
export default {
    components: { Loading, tabMenuClient, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            viewing_mode: 'list',
            client: {},
            directories: {},
            files: {},
            roles: {},
            roles_options: [],
            hierarchy_directories: {},
            sequence_directories: [],
            modalDisplayNewDirectory: 'none',
            modalDisplayEditDirectory: 'none',
            modalDisplayNewFile: 'none',
            modalDisplayEditFile: 'none',
            progressBarFile: 0,
            client_id: '',
            from: null,
            to: null,
            role_multiselect: [],
            directory_before: null,
            directory_to: null,
            enable_error_list: false,
            errors: [],
            request_confirmation_multiselect: { type: '0', value: 'Não' },
            request_confirmation_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            directory: {
                name: '',
                from: null,
                role_id: '',
                client_id: '',
                directory_id: ''
            },
            files_upload: [],
            file: {
                description: '',
                from: null,
                archive: null,
                client_id: '',
                directory_id: '',
                size: '',
                overdue: '',
                request_confirmation: '0'
            }
        }
    },

    computed: {
        isDisabledDirectory: function () {
            return this.directory.name != '' && this.role_multiselect.length > 0;
        },
        isDisabledFile: function () {
            return this.files_upload.length > 0;
        },
        isDisabledFileUpdate: function () {
            return this.file.description != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.client_id = id;
        this.getFileClient();
        const response_roles = this.getRoles();
        response_roles.then(() => {
            this.roles_options = this.roles.map(item => ({
                key: item.id,
                value: item.name
            }));
            this.roles_options.unshift({ key: 'all', value: 'Todos os perfis' });
        });

    },

    methods: {
        onCancel() { },
        initializeData() {

        },

        changeViewingMode() {
            if (this.viewing_mode == 'list') {
                this.viewing_mode = 'card';
            } else {
                this.viewing_mode = 'list';
            }

        },

        beforeDirectory(before) {
            this.sequence_directories.pop();
            this.to = before;
            this.getFileClient();
        },

        enterDirectory(next, name = '') {
            this.to = next;
            this.sequence_directories.push(name + " /  ");
            this.getFileClient();
        },

        requestConfirmationWithLang({ value }) {
            return value;
        },

        roleWithLang({ value }) {
            return value;
        },
        handleSelectRequestConfirmation(option) {
            this.file.request_confirmation = option.type;
        },

        getFileClient() {
            this.isLoading = true;
            api.get('/client/' + this.client_id + '/files-office', {
                params: {
                    'from': this.to
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.directories = response.data.directories;
                    this.hierarchy_directories = response.data.hierarchyDirectories;
                    this.files = response.data.files;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        createNewDirectory(event) {
            event.preventDefault();
            this.directory.from = this.to;
            this.isLoading = true;
            const roles_selected = [];
            this.role_multiselect.forEach(user_id => {
                roles_selected.push(user_id.key);
            });
            this.directory.roles = roles_selected;
            api.post('/client/' + this.client_id + '/newDirectoryOffice', this.directory)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Diretório cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.closeModalNewDirectory();
                    this.role_multiselect = [];
                    this.directory = {};
                    this.getFileClient();
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalNewDirectory();
                    if (error.status == 422) {
                        this.$notify({
                            title: "Falha",
                            text: "Diretório já existente neste nível!",
                            type: 'error'
                        });
                    } else {
                        handleRequestErrors(error.status, error);
                    }
                })
        },

        editDirectory(directory_id) {
            this.role_multiselect = [];
            this.directories.forEach(directory => {
                if (directory.id == directory_id) {
                    this.directory.directory_id = directory_id;
                    this.directory.name = directory.to.name;
                    this.directory.role_id = directory.to.role != null ? directory.to.role.id : 'all';
                    this.directory.client_id = this.client_id;
                    if (directory.to.role != null) {
                        this.directory.role_id = directory.to.role.id;
                        this.role_multiselect.push({ key: directory.to.role.id, value: directory.to.role.name == 'all' ? 'Todos os perfis' : directory.to.role.name });
                        directory.to.roles.forEach(role => {
                            this.role_multiselect.push({ key: role.id, value: role.name })
                        });
                    } else {
                        this.directory.role_id = 'all';
                        this.role_multiselect = { key: 'all', value: 'Todos os perfis' };
                    }
                    this.showModalEditDirectory();
                }
            });
        },

        updateDirectory(event) {
            event.preventDefault();
            this.directory.from = this.to;
            this.isLoading = true;
            const roles_selected = [];
            this.role_multiselect.forEach(user_id => {
                roles_selected.push(user_id.key);
            });
            this.directory.roles = roles_selected;
            api.put('/client/' + this.directory.directory_id + '/updateOffice', this.directory)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Diretório atualizado com sucesso!",
                        type: 'success'
                    });
                    this.closeModalEditDirectory();
                    this.role_multiselect = [];
                    this.directory = {};
                    this.getFileClient();
                    this.directory.name = '';

                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalEditDirectory();
                    if (error.status == 422) {
                        this.$notify({
                            title: "Falha",
                            text: "Diretório já existente neste nível!",
                            type: 'error'
                        });
                    } else {
                        handleRequestErrors(error.status, error);
                    }

                })
        },


        removeDirectory(directory_id) {
            this.$confirm(
                {
                    message: 'Deseja remover o diretório?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/client/' + directory_id + "/removeDirectoryOffice")
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Diretório excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.getFileClient();

                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        mirrorAreaClient(name, directory_to) {
            let id = directory_to;
            console.log(id);
            this.$confirm(
                {
                    message: 'Deseja espelhar todos os arquivos do diretório ' + name + '?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/client/' + id + "/replicateFilesFromOfficeToAreaClient")
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Arquivos espelhados com sucesso",
                                        type: 'success'
                                    });
                                    this.getFileClient();

                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        handleFileChange(event) {
            if (event.target.files != undefined) {
                const files = event.target.files;
                [...files].forEach(file => {
                    const sizeInBytes = file.size;
                    const sizeInMB = sizeInBytes / (1024 * 1024);
                    if (sizeInMB > 10) {
                        this.$notify({
                            title: "Informação",
                            text: "O arquivo (" + file.name + ") excede o limite de envio. O máximo para envio são 10MB",
                            type: 'info'
                        });
                        this.files_upload = [];
                    } else {
                        this.files_upload.push(file);
                    }
                });

            } else {
                this.file.size = '';
                this.file.archive = null;
            }

            this.$refs.fileInput.value = null;

        },

        removeFileList(file_remove) {
            this.files_upload.forEach((file) => {
                if (file_remove.name == file.name && file_remove.size == file.size && file_remove.type == file.type) {
                    let index = this.files_upload.indexOf(file_remove.name);
                    this.files_upload.splice(index, 1);
                }
            });

            if (this.files_upload.length == 0) {
                this.files_upload = [];
            }
        },

        createNewFile(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.file.from = this.to;
            this.isLoading = true;
            let total_upload_success = 0;
            let total_upload_error = 0;
            let total_files = this.files_upload.length;
            this.files_upload.forEach((file) => {
                this.progressBarFile = 0;
                const formData = new FormData();
                formData.append('description', file.name);
                formData.append('file', file);
                formData.append('from', this.file.from);
                formData.append('overdue', this.file.overdue);
                formData.append('request_confirmation', this.file.request_confirmation);
                api.post('/client/' + this.client_id + '/newFileOffice', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: progressEvent => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        this.progressBarFile = percentCompleted;
                    }
                })
                    .then(() => {
                        total_upload_success++;
                    }).catch(error => {
                        total_upload_error++;
                        if (error.status == 422) {
                            this.$notify({
                                title: "Falha",
                                text: "Arquivo já existente neste nível!",
                                type: 'error'
                            });
                        }
                    })
            });

            const interval = setInterval(() => {
                if (total_upload_success + total_upload_error >= total_files) {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Arquivos enviados com sucesso! Foram enviados " + total_upload_success + " com " + total_upload_error + " erros detectados",
                        type: 'success'
                    });
                    this.closeModalNewFile();
                    this.role_multiselect = [];
                    this.files_upload = [];
                    this.file = {};
                    this.progressBarFile = 0;
                    this.getFileClient();
                    clearInterval(interval);
                }
            }, 2000);

        },

        editFile(file_id) {
            this.files.forEach(file => {
                if (file.id == file_id) {
                    this.file.file_id = file_id;
                    this.file.description = file.description;
                    this.file.overdue = file.overdue;
                    this.file.client_id = this.client_id;
                    this.file.request_confirmation = file.request_confirmation;
                    if (file.request_confirmation) {
                        this.request_confirmation_multiselect = { type: '1', value: 'Sim' };
                    } else {
                        this.request_confirmation_multiselect = { type: '0', value: 'Não' };
                    }
                    this.showModalEditFile();
                }
            });
        },

        updateFile(event) {
            event.preventDefault();
            this.isLoading = true;
            api.put('/client/' + this.file.file_id + '/updateFileOffice', this.file)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Arquivo atualizado com sucesso!",
                        type: 'success'
                    });
                    this.file.description = '';
                    this.file.overdue = '';
                    this.file.request_confirmation = '0';
                    this.request_confirmation_multiselect = { type: '0', value: 'Não' };
                    this.closeModalEditFile();
                    this.getFileClient();
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalEditFile();
                    if (error.status == 422) {
                        this.$notify({
                            title: "Falha",
                            text: "Arquivo já existente neste nível!",
                            type: 'error'
                        });
                    } else {
                        handleRequestErrors(error.status, error);
                    }

                })
        },

        removeFile(directory_id) {
            this.$confirm(
                {
                    message: 'Deseja remover o arquivo?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/client/' + directory_id + "/removeFileOffice")
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Arquivo excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.getFileClient();

                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        generateRandom() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

        async downloadFile(file_id) {
            this.isLoading = true;
            api.get('/client/' + file_id + '/downloadFileOffice', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    link.download = 'download_' + this.generateRandom();
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalNewFile();
                    handleRequestErrors(error.status, error);
                })
        },

        async getRoles() {
            this.isLoading = true;
            const response = api.get('/rolesAll')
                .then((response) => {
                    this.roles = response.data.roles;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },

        showModalNewDirectory() {
            this.modalDisplayNewDirectory = 'block';
        },
        closeModalNewDirectory() {
            this.modalDisplayNewDirectory = 'none';
            this.role_multiselect = [];
            this.directory.name = '';
        },
        showModalEditDirectory() {
            this.modalDisplayEditDirectory = 'block';
        },
        closeModalEditDirectory() {
            this.modalDisplayEditDirectory = 'none';
            this.role_multiselect = [];
            this.directory.name = '';
        },
        showModalNewFile() {
            this.modalDisplayNewFile = 'block';
        },
        closeModalNewFile() {
            this.modalDisplayNewFile = 'none';
        },
        showModalEditFile() {
            this.modalDisplayEditFile = 'block';
        },
        closeModalEditFile() {
            this.modalDisplayEditFile = 'none';
        },
    }
}
</script>

<style>
.pointer {
    cursor: pointer;
}

.modal {
    position: fixed;
    z-index: 1999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #f5f5f5;
    margin: 3% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 65%;
}

.modal-header {
    color: #000;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.directory {
    color: #a70000;
}

.file {
    color: #000fe6;
}

@media (max-width: 576px) {
    .modal-content {
        width: 90% !important;
    }
}
</style>